export default "__VITE_PUBLIC_ASSET__c215e70b__"